module.exports = __webpack_public_path__ + "img/RBS_event_03.b8c0e34a.jpg";